// Site içindeki tüm sayfaların arama verileri
export const searchData = [
  // Home Page
  {
    title: 'Home',
    url: '/',
    content: 'Nova Quality Certification Agency - Testing and Conformity Assessment Certification. NQC provides comprehensive certification services for businesses worldwide.',
    category: 'Home'
  },
  
  // Corporate Pages
  {
    title: 'About Us',
    url: '/about',
    content: 'About NQC - Nova Quality Certification Agency. Learn about our services, expertise, and commitment to quality certification.',
    category: 'Corporate'
  },
  {
    title: 'Quality Policy',
    url: '/quality-policy',
    content: 'Quality Policy of NQC. Our commitment to maintaining the highest standards in certification services.',
    category: 'Corporate'
  },
  {
    title: 'Our Mission',
    url: '/our-mission',
    content: 'Our Mission at NQC. Delivering excellence in certification services and helping businesses achieve their quality goals.',
    category: 'Corporate'
  },
  {
    title: 'Our Vision',
    url: '/our-vision',
    content: 'Our Vision at NQC. Leading the certification industry with innovation and excellence.',
    category: 'Corporate'
  },
  
  // System Certification Pages
  {
    title: 'ISO 9001 Quality Management System',
    url: '/iso-9001',
    content: 'ISO 9001 Quality Management System certification. Improve quality, customer satisfaction, and operational efficiency.',
    category: 'System Certification'
  },
  {
    title: 'BS EN ISO 9001:2015',
    url: '/iso-9001',
    content: 'BS EN ISO 9001:2015 British Standard for Quality Management System. UK version of ISO 9001:2015 standard.',
    category: 'System Certification'
  },
  {
    title: 'ISO 14001 Environmental Management System',
    url: '/iso-14001',
    content: 'ISO 14001 Environmental Management System. Manage environmental impacts and achieve sustainability goals.',
    category: 'System Certification'
  },
  {
    title: 'ISO 45001 Occupational Health and Safety Management System',
    url: '/iso-45001',
    content: 'ISO 45001 Occupational Health and Safety Management System. Protect workers and improve workplace safety.',
    category: 'System Certification'
  },
  {
    title: 'ISO 22000 Food Safety Management System',
    url: '/iso-22000',
    content: 'ISO 22000 Food Safety Management System. Ensure food safety throughout the supply chain.',
    category: 'System Certification'
  },
  {
    title: 'ISO 13485 Quality Management System for Medical Devices',
    url: '/iso-13485',
    content: 'ISO 13485 Medical Devices Quality Management System. Ensure quality and safety of medical devices.',
    category: 'System Certification'
  },
  {
    title: 'ISO 27001 Information Security Management System',
    url: '/iso-27001',
    content: 'ISO 27001 Information Security Management System. Protect information assets and manage security risks.',
    category: 'System Certification'
  },
  {
    title: 'ISO 20000-1 Information Technology Service Management System',
    url: '/iso-20000',
    content: 'ISO 20000-1 IT Service Management System. Improve IT service quality and efficiency.',
    category: 'System Certification'
  },
  {
    title: 'ISO 27701 Personal Data Management System',
    url: '/iso-27701',
    content: 'ISO 27701 Personal Data Management System. Ensure privacy and data protection compliance.',
    category: 'System Certification'
  },
  {
    title: 'ISO 16949 Automotive Quality Management System',
    url: '/iso-16949',
    content: 'ISO 16949 Automotive Quality Management System. Meet automotive industry quality standards.',
    category: 'System Certification'
  },
  {
    title: 'ISO 50001 Energy Management System',
    url: '/iso-50001',
    content: 'ISO 50001 Energy Management System. Improve energy efficiency and reduce costs.',
    category: 'System Certification'
  },
  {
    title: 'ISO 22301 Societal Security and Business Continuity Management System',
    url: '/iso-22301',
    content: 'ISO 22301 Business Continuity Management System. Ensure business resilience and continuity.',
    category: 'System Certification'
  },
  {
    title: 'ISO 37001 Corruption Management System',
    url: '/iso-37001',
    content: 'ISO 37001 Anti-Bribery Management System. Fight corruption and ensure ethical business practices.',
    category: 'System Certification'
  },
  {
    title: 'ISO 10002 Customer Satisfaction Management System',
    url: '/iso-10002',
    content: 'ISO 10002 Customer Satisfaction Management System. Improve customer satisfaction and complaint handling.',
    category: 'System Certification'
  },
  {
    title: 'ISO 28001 Supply Chain Security Management System',
    url: '/iso-28001',
    content: 'ISO 28001 Supply Chain Security Management System. Secure your supply chain and manage risks.',
    category: 'System Certification'
  },
  {
    title: 'ISO 22483 Tourism Quality Management System',
    url: '/iso-22483',
    content: 'ISO 22483 Tourism Quality Management System. Enhance quality standards in the tourism sector.',
    category: 'System Certification'
  },
  {
    title: 'ISO 14064 Carbon Footprint Verification',
    url: '/iso-14064',
    content: 'ISO 14064 Carbon Footprint Verification. Measure and verify greenhouse gas emissions.',
    category: 'System Certification'
  },
  {
    title: 'ISO 14046 Water Footprint Verification',
    url: '/iso-14046',
    content: 'ISO 14046 Water Footprint Verification. Measure and assess water use and environmental impact.',
    category: 'System Certification'
  },
  {
    title: 'ISO 31000 Enterprise Risk Management System',
    url: '/iso-31000',
    content: 'ISO 31000 Enterprise Risk Management System. Manage risks effectively and ensure business resilience.',
    category: 'System Certification'
  },
  {
    title: 'ISO 39001 Road Traffic Safety Management System',
    url: '/iso-39001',
    content: 'ISO 39001 Road Traffic Safety Management System. Improve road safety and reduce accidents.',
    category: 'System Certification'
  },
  
  // Product Certification Pages
  {
    title: 'CE Certification',
    url: '/ce-certification',
    content: 'CE Certification for products sold in the European Union. Ensure compliance with EU directives.',
    category: 'Product Certification'
  },
  {
    title: 'BRC Certificate',
    url: '/brc-certificate',
    content: 'BRC Certificate for food safety and quality. Essential for food producers and retailers.',
    category: 'Product Certification'
  },
  {
    title: 'Kosher Certificate',
    url: '/kosher-certificate',
    content: 'Kosher Certificate for products produced according to Jewish religious laws.',
    category: 'Product Certification'
  },
  {
    title: 'FSSC 22000 Certificate',
    url: '/fssc-22000',
    content: 'FSSC 22000 Food Safety Certification. Internationally recognized food safety standard.',
    category: 'Product Certification'
  },
  
  // Quality Certification Pages
  {
    title: 'ROHS Certificate',
    url: '/rohs-certificate',
    content: 'ROHS Certificate for restriction of hazardous substances in electronic equipment.',
    category: 'Quality Certification'
  },
  {
    title: 'AS 9100 Certificate',
    url: '/as-9100',
    content: 'AS 9100 Certificate for aerospace, space, and defense industry quality management.',
    category: 'Quality Certification'
  },
  {
    title: 'GHP Certificate',
    url: '/ghp-certificate',
    content: 'GHP Certificate for Good Hygiene Practices in food production and processing.',
    category: 'Quality Certification'
  },
  {
    title: 'GMP Certificate',
    url: '/gmp-certificate',
    content: 'GMP Certificate for Good Manufacturing Practices in pharmaceuticals, food, and cosmetics.',
    category: 'Quality Certification'
  },
  {
    title: 'WRAS Certificate',
    url: '/wras-certificate',
    content: 'WRAS Certificate for water regulations compliance in England and Wales.',
    category: 'Quality Certification'
  },
  
  // General Information Pages
  {
    title: 'System Certification',
    url: '/system-certification',
    content: 'System Certification services. Comprehensive management system certifications for quality, safety, and compliance.',
    category: 'Services'
  },
  {
    title: 'Product Certification',
    url: '/product-certification',
    content: 'Product Certification services. Verify products meet standards and regulations for market access.',
    category: 'Services'
  },
  {
    title: 'Quality Certification',
    url: '/quality-certification',
    content: 'Quality Certification services. Ensure products and processes meet quality standards.',
    category: 'Services'
  },
  {
    title: 'Contact',
    url: '/contact',
    content: 'Contact NQC - Nova Quality Certification Agency. Get in touch with our expert team.',
    category: 'Contact'
  }
];

// Arama fonksiyonu
export const searchSite = (query) => {
  if (!query || query.trim().length === 0) {
    return [];
  }
  
  const searchTerm = query.toLowerCase().trim();
  const results = [];
  
  searchData.forEach((item) => {
    const titleMatch = item.title.toLowerCase().includes(searchTerm);
    const contentMatch = item.content.toLowerCase().includes(searchTerm);
    const categoryMatch = item.category.toLowerCase().includes(searchTerm);
    
    if (titleMatch || contentMatch || categoryMatch) {
      let relevance = 0;
      if (titleMatch) relevance += 3;
      if (contentMatch) relevance += 2;
      if (categoryMatch) relevance += 1;
      
      // İçeriğin hangi kısmında geçtiğini bul
      const contentLower = item.content.toLowerCase();
      const index = contentLower.indexOf(searchTerm);
      let snippet = item.content;
      
      if (index !== -1) {
        const start = Math.max(0, index - 50);
        const end = Math.min(item.content.length, index + searchTerm.length + 50);
        snippet = '...' + item.content.substring(start, end) + '...';
      }
      
      results.push({
        ...item,
        relevance,
        snippet
      });
    }
  });
  
  // Relevance'ye göre sırala
  results.sort((a, b) => b.relevance - a.relevance);
  
  return results;
};

